import { render } from "./SlimResults.vue?vue&type=template&id=47cc1ad9"
import script from "./SlimResults.vue?vue&type=script&lang=js"
export * from "./SlimResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__